module.exports = __webpack_public_path__ + "media/images/e-bilet/basket-87b4d9b5e0809b4e17ea5b0724875fbe.svg";